module.exports = __webpack_public_path__ + "img/bg_yay-2.b3b37ae4.svg";